export default __webpack_public_path__ + "static/media/Icons_Email Sent Icon.963e6350.svg";